var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSad = function SvgSad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 260 260"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M130 21.666c-59.735 0-108.333 48.598-108.333 108.333S70.265 238.333 130 238.333s108.334-48.599 108.334-108.334S189.735 21.666 130 21.666m0 195c-47.785 0-86.666-38.881-86.666-86.667 0-47.785 38.88-86.666 86.666-86.666s86.667 38.88 86.667 86.666-38.881 86.667-86.667 86.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M92.083 130c8.975 0 16.25-7.275 16.25-16.25s-7.275-16.25-16.25-16.25-16.25 7.275-16.25 16.25S83.108 130 92.083 130M167.841 129.848c8.933 0 16.174-7.241 16.174-16.174S176.774 97.5 167.841 97.5s-16.174 7.241-16.174 16.174 7.241 16.174 16.174 16.174M130 151.666c-32.5 0-43.333 32.5-43.333 32.5h86.667s-10.834-32.5-43.334-32.5"
  })));
};
export default SvgSad;